<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Agentes</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" lg="3" class="mt-4 mb-2 d-none d-lg-block">
                <b-button variant="default" pill block size="sm" @click="clearData" v-b-modal.partner>
                    <i class="material-icons mdi mdi-store-plus"></i>&nbsp;
                    <span>Nuevo Agente</span>
                </b-button>
            </b-col>
            <b-col cols="12" lg="9" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar"
                            class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''"
                                class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table :items="items" :fields="fields" responsive="sm" class="my-2 border-bottom" stacked="sm" hover
                    small show-empty no-border-collapse table-variant="light" details-td-class="px-0"
                    empty-filtered-text="No hay Agentes que coincidan con la búsqueda"
                    empty-text="No hay Agentes para mostrar" :current-page="currentPage" :per-page="perPage"
                    :filter="search" :busy="isBusy" @filtered="onFiltered">
                    <template #cell(tariff_model)="row">
                        {{ row.item.tariff_model === 0 ? 'mensual' : 'diario' }}
                    </template>
                    <template #cell(balance)="row">
                        <template v-if="row.item.balance >= 0">
                            <b class="text-success">{{ row.item.balance_text }}</b>
                        </template>
                        <template v-else>
                            <b class="text-danger">{{ row.item.balance_text }}</b>
                        </template>
                    </template>

                    <template #cell(actions)="row">
                        <b-button variant="default" size="sm" title="Ver Cuenta Corriente"
                            :to="'partners/wallet/' + (row.item.tariff_model === 0 ? 'monthly' : 'daily') + '/' + row.item.id">
                            <i class="material-icons">wallet</i>
                        </b-button>
                        <b-button variant="primary" size="sm" title="Ver Sucursales"
                            :to="'partners/branch/' + row.item.code">
                            <i class="material-icons">holiday_village</i>
                        </b-button>
                        <b-button variant="info" size="sm" title="Ver Mapa"
                            @click="clearData(row.item.id, row.item.maps)">
                            <i class="material-icons">place</i>
                        </b-button>
                        <b-button variant="warning" size="sm" title="Configurar Horario de Trabajo" @click="getWorkSchedule(row.item.code)" v-b-modal.workSchedule>
                            <i class="material-icons">schedule</i>
                        </b-button>
                        <b-button variant="warning" size="sm" title="Editar" @click="clearData(row.item.id)"
                            v-b-modal.partner>
                            <i class="material-icons">edit</i>
                        </b-button>
                        <b-button variant="danger" size="sm" title="Eliminar" @click="trash(row.item.id)">
                            <i class="material-icons">delete</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal Map Viewer -->
                <b-modal id="map" centered no-fade header-class="text-center" header-bg-variant="primary"
                    header-text-variant="light" header-close-variant="light" footer-class="border-0" hide-footer
                    body-class="text-center px-4 my-4" :title="'ID: ' + form.id" tabindex="-1" role="dialog" size="lg"
                    aria-hidden="true">
                    <iframe :src="'https://www.google.com/maps/embed?pb=' + form.maps" width="100%" height="450"
                        style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                </b-modal>

                <!-- Modal Add/Edit Office Partner -->
                <b-modal id="partner" centered no-fade header-class="text-center" header-bg-variant="primary"
                    header-text-variant="light" header-close-variant="light" footer-class="border-0" hide-footer
                    body-class="text-center px-4 my-4"
                    :title="(form.id ? 'Editar' : 'Agregar') + ' Agente' + (form.id ? (' ID: ' + form.id) : '')"
                    tabindex="-1" role="dialog" size="lg" aria-hidden="true">
                    <b-form id="formPartner" @submit.stop.prevent="form.id > 0 ? exec(form.id) : exec()">
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.company + ':'">
                                    <b-form-input name="company" v-model="form.company" type="text" class="text-center"
                                        v-validate="'required:true'" :state="validateState('company')"
                                        :data-vv-as="(labels.company).toLowerCase()" :disabled="loading"
                                        aria-describedby="company-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="company-live-feedback">{{
                                        veeErrors.first('company')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.rut + ':'">
                                    <b-form-input name="rut" v-model="form.rut" type="text" class="text-center"
                                        v-validate="'required:true'" :state="validateState('rut')"
                                        :data-vv-as="(labels.rut).toLowerCase()" :disabled="loading"
                                        aria-describedby="rut-live-feedback" v-mask="mask"></b-form-input>
                                    <b-form-invalid-feedback id="rut-live-feedback">{{
                                        veeErrors.first('rut')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.code + ':'">
                                    <b-form-input name="code" v-model="form.code" type="text" class="text-center"
                                        v-validate="'required:true'" :state="validateState('code')"
                                        :data-vv-as="(labels.code).toLowerCase()" :disabled="loading || form.id > 0"
                                        aria-describedby="code-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="code-live-feedback">{{
                                        veeErrors.first('code')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.name + ':'">
                                    <b-form-input name="name" v-model="form.name" type="text" class="text-center"
                                        v-validate="'required:true'" :state="validateState('name')"
                                        :data-vv-as="(labels.name).toLowerCase()" :disabled="loading"
                                        aria-describedby="name-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="name-live-feedback">{{
                                        veeErrors.first('name')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.alias + ':'">
                                    <b-form-input name="alias" v-model="form.alias" type="text" class="text-center"
                                        v-validate="'required:true'" :state="validateState('alias')"
                                        :data-vv-as="(labels.alias).toLowerCase()" :disabled="loading"
                                        aria-describedby="alias-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="alias-live-feedback">{{
                                        veeErrors.first('alias')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.phone + ':'">
                                    <b-form-input name="phone" v-model="form.phone" type="text" class="text-center"
                                        v-validate="'required:true'" :state="validateState('phone')"
                                        :data-vv-as="(labels.phone).toLowerCase()" :disabled="loading"
                                        aria-describedby="phone-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="phone-live-feedback">{{
                                        veeErrors.first('phone')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.tariff_model + ':'">
                                    <b-form-select name="tariff_model" :options="tariff_model_options"
                                        :value="form.tariff_model" v-model="form.tariff_model"
                                        class="form-control select-center" v-validate="'required:true'"
                                        :state="validateState('tariff_model')"
                                        :data-vv-as="(labels.tariff_model).toLowerCase()" :disabled="loading"
                                        aria-describedby="tariff_model-live-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="tariff_model-live-feedback">{{
                                        veeErrors.first('tariff_model')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.email + ':'">
                                    <b-form-input name="email" v-model="form.email" type="email" inputmode="email"
                                        class="text-center" v-validate="'required:true'" :state="validateState('email')"
                                        :data-vv-as="(labels.email).toLowerCase()" :disabled="loading"
                                        aria-describedby="email-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="email-live-feedback">{{
                                        veeErrors.first('email')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.address + ':'">
                                    <b-form-input name="address" v-model="form.address" type="text" class="text-center"
                                        v-validate="'required:true'" :state="validateState('address')"
                                        :data-vv-as="(labels.address).toLowerCase()" :disabled="loading"
                                        aria-describedby="address-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="address-live-feedback">{{
                                        veeErrors.first('address')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.city + ':'">
                                    <b-form-input name="city" v-model="form.city" type="text" class="text-center"
                                        v-validate="'required:true'" :state="validateState('city')"
                                        :data-vv-as="(labels.city).toLowerCase()" :disabled="loading"
                                        aria-describedby="city-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="city-live-feedback">{{
                                        veeErrors.first('city')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.state + ':'">
                                    <b-form-input name="state" v-model="form.state" type="text" class="text-center"
                                        v-validate="'required:true'" :state="validateState('state')"
                                        :data-vv-as="(labels.state).toLowerCase()" :disabled="loading"
                                        aria-describedby="state-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="state-live-feedback">{{
                                        veeErrors.first('state')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.maps + ':'">
                                    <b-form-input name="maps" v-model="form.maps" type="text" class="text-center"
                                        v-validate="'required:true'" :state="validateState('maps')"
                                        :data-vv-as="(labels.maps).toLowerCase()" :disabled="loading"
                                        aria-describedby="maps-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="maps-live-feedback">{{
                                        veeErrors.first('maps')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.currency_1 + ':'">
                                    <b-form-select name="currency_1" :options="yes_no" :value="form.currency_1"
                                        v-model="form.currency_1" class="form-control select-center"
                                        v-validate="'required:true'" :state="validateState('currency_1')"
                                        :data-vv-as="(labels.currency_1).toLowerCase()" :disabled="loading"
                                        aria-describedby="currency_1-live-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="currency_1-live-feedback">{{
                                        veeErrors.first('currency_1')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.currency_2 + ':'">
                                    <b-form-select name="currency_2" :options="yes_no" :value="form.currency_2"
                                        v-model="form.currency_2" class="form-control select-center"
                                        v-validate="'required:true'" :state="validateState('currency_2')"
                                        :data-vv-as="(labels.currency_2).toLowerCase()" :disabled="loading"
                                        aria-describedby="currency_2-live-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="currency_2-live-feedback">{{
                                        veeErrors.first('currency_2')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.open + ':'">
                                    <b-form-input name="open" v-model="form.open" type="text" class="text-center"
                                        v-validate="'required:true'" :state="validateState('open')"
                                        :data-vv-as="(labels.open).toLowerCase()" :disabled="loading"
                                        aria-describedby="open-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="open-live-feedback">{{
                                        veeErrors.first('open')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.earnings + ':'">
                                    <b-form-input name="earnings" v-model="form.earnings" type="text"
                                        class="text-center" v-validate="'required:true|min_value:0|max_value:100'"
                                        :state="validateState('earnings')" :data-vv-as="(labels.earnings).toLowerCase()"
                                        :disabled="loading" aria-describedby="earnings-live-feedback"></b-form-input>
                                    <b-form-invalid-feedback id="earnings-live-feedback">{{
                                        veeErrors.first('earnings')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill
                                    class="shadow align-middle px-5" form="formPartner" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? (form.id === 0 ? 'Guardando...' : 'Actualizando...')
                                        : (form.id === 0
                                            ? 'Guardar' : 'Actualizar') }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>

                <!-- Modal Work Schedule -->
                <b-modal
                    id="workSchedule"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    title="Configurar Horario de Trabajo"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <b-form id="formWorkSchedule" @submit.stop.prevent="updateWorkSchedule(workScheduleForm.partnerCode)">
                        <b-row align-h="center">
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group>
                                    <b-form-checkbox
                                        v-model="workScheduleForm.work_schedule_enabled"
                                        name="work_schedule_enabled"
                                        switch
                                        size="lg">
                                        <strong>Habilitar Restricción Horaria</strong>
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-if="workScheduleForm.work_schedule_enabled">
                                <b-form-group label="Hora de Inicio:">
                                    <b-form-timepicker
                                        v-model="workScheduleForm.work_start_time"
                                        name="work_start_time"
                                        v-validate="workScheduleForm.work_schedule_enabled ? 'required:true' : ''"
                                        :state="validateState('work_start_time')"
                                        :data-vv-as="'Hora de inicio'"
                                        :disabled="loading"
                                        locale="es"
                                        class="text-center"
                                        aria-describedby="work_start_time-live-feedback"
                                    ></b-form-timepicker>
                                    <b-form-invalid-feedback id="work_start_time-live-feedback">
                                        {{ veeErrors.first('work_start_time') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-if="workScheduleForm.work_schedule_enabled">
                                <b-form-group label="Hora de Fin:">
                                    <b-form-timepicker
                                        v-model="workScheduleForm.work_end_time"
                                        name="work_end_time"
                                        v-validate="workScheduleForm.work_schedule_enabled ? 'required:true' : ''"
                                        :state="validateState('work_end_time')"
                                        :data-vv-as="'Hora de fin'"
                                        :disabled="loading"
                                        locale="es"
                                        class="text-center"
                                        aria-describedby="work_end_time-live-feedback"
                                    ></b-form-timepicker>
                                    <b-form-invalid-feedback id="work_end_time-live-feedback">
                                        {{ veeErrors.first('work_end_time') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="shadow align-middle px-5" form="formWorkSchedule" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? 'Actualizando...' : 'Actualizar' }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group label="Mostrar:" label-for="per-page-select" label-cols-sm="4" label-cols-md="6"
                    label-cols-lg="9" label-align-sm="right" label-size="sm" class="mt-2 mb-8">
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"
                        size="sm"></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm"
                    class="mt-2 mb-8"></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Partners",
    data: () => ({
        labels: {
            company: 'Nombre Legal',
            rut: 'RUT',
            code: 'Código',
            name: 'Nombre',
            tariff_model: 'Modelo de Tarifa',
            alias: 'Alias',
            phone: 'Teléfono',
            email: 'email',

            address: 'Dirección',
            city: 'Ciudad',
            state: 'Estado',
            maps: 'Ubicación GPS',

            currency_1: 'Moneda Local',
            currency_2: 'Dolares',
            open: 'Horario',
            earnings: 'Porcentaje'
        },
        form: {
            id: 0,
            company: null,
            rut: null,
            code: null,
            name: null,
            alias: null,
            phone: null,
            email: null,

            address: null,
            city: null,
            state: null,
            maps: null,

            currency_1: null,
            currency_2: null,
            open: null,
            earnings: null
        },
        yes_no: [
            { text: 'Si', value: '1' },
            { text: 'No', value: '0' }
        ],
        tariff_model_options: [
            { text: 'Mensual', value: '0' },
            { text: 'Diario', value: '1' }
        ],
        loading: false,
        isBusy: true,
        search: '',
        fields: [
            { key: 'code', label: 'Código', sortable: false },
            { key: 'name', label: 'Nombre', sortable: false },
            { key: 'tariff_model', label: 'Modelo de tarifa', sortable: false },
            { key: 'alias', label: 'Alias', sortable: false },
            { key: 'phone', label: 'Teléfono', sortable: false },
            { key: 'currencies', label: 'Monedas', sortable: false },
            { key: 'balance', label: 'Saldo USD', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'actions', label: 'Acción', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }],
        mask: '##.###.###-N',
        workScheduleForm: {
            partnerCode: null,
            work_schedule_enabled: false,
            work_start_time: null,
            work_end_time: null,
            timezone: 'America/Santiago'
        },
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'partnerspage');
        this.getIni();
    },
    watch: {
        'workScheduleForm.work_schedule_enabled'(newVal) {
            if (newVal && !this.workScheduleForm.work_start_time && !this.workScheduleForm.work_end_time) {
                // Establecer valores por defecto: 9AM a 6PM
                this.workScheduleForm.work_start_time = '09:00:00';
                this.workScheduleForm.work_end_time = '18:00:00';
            }
        }
    },
    methods: {
        getIni() {
            axios.get('/api/settings/partners').then((res) => {
                if (res.data.status === 'success') {
                    console.log(`/api/settings/partners DATA:`, res.data)
                    this.items = res.data.items;
                    this.totalRows = this.items.length;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
        },
        clearData(id, map) {
            this.form = {
                id: 0,
                code: null,
                company: null,
                rut: null,
                name: null,
                alias: null,
                phone: null,
                email: null,

                address: null,
                city: null,
                state: null,
                maps: null,

                currency_1: null,
                currency_2: null,
                open: null,
                earnings: null,
                tariff_model: null
            };
            if (id) {
                const items = this.items;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.form = items[i];
                    }
                }
                if (map) {
                    this.$bvModal.show('map');
                }
            }
        },
        exec(id) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                let url = 'add';
                if (id) {
                    url = id + '/edit';
                }
                axios.post('/api/settings/partners/' + url, this.form).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getIni();
                        this.$bvModal.hide('partner');
                        this.clearData();
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        trash(id) {
            let office = '';
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    office = items[i].alias;
                }
            }

            this.$swal({
                title: '¿Estas seguro de eliminar este agente?',
                text: 'Oficina: ' + office,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'En otro momento',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    axios.get('/api/settings/partners/' + id + '/delete').then((res) => {
                        if (res.data.status === 'success') {
                            for (let i = 0; i < items.length; i++) {
                                if (items[i].id === id) {
                                    items.splice(i, 1);
                                    this.totalRows = this.items.length;
                                }
                            }
                        }
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        getWorkSchedule(partnerCode) {
            this.workScheduleForm.partnerCode = partnerCode;
            axios.get('/api/users/' + partnerCode + '/work-schedule').then((res) => {
                if (res.data.status === 'success') {
                    const schedule = res.data.work_schedule;
                    this.workScheduleForm = {
                        partnerCode: partnerCode,
                        work_schedule_enabled: schedule.work_schedule_enabled || false,
                        work_start_time: schedule.work_start_time || null,
                        work_end_time: schedule.work_end_time || null,
                        timezone: 'America/Santiago'
                    };
                } else {
                    this.$root.$bvToast.toast(res.data.msg || 'Error al cargar horario', {
                        title: 'Error',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response?.data?.errors || 'Error al cargar horario', {
                    title: 'Error',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        updateWorkSchedule(partnerCode) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                axios.post('/api/users/' + partnerCode + '/work-schedule/update', this.workScheduleForm).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getIni();
                        this.$bvModal.hide('workSchedule');
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response?.data?.errors || 'Error al actualizar horario', {
                        title: 'Error',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        }
    }
}
</script>

<style scoped></style>
